import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchall'
})
export class SearchallPipe implements PipeTransform {

  transform(value: any, args: any): unknown {
    if(!value) {
      return;
    }

    if(!args) {
      return value;
    }

    args = args.toLowerCase();
    return value.filter( (item) => {
      return JSON.stringify(item.payload.doc.data()).toLowerCase().includes(args);
    });
  }

}
